import dayjs from 'dayjs';

const getEasterDate = year => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  return dayjs(`${year}-${month}-${day}`, 'YYYY-M-D');
};

function getHanukkahDate(year) {
  const knownDates = {
    2025: '12-14',
    2026: '12-04',
    2027: '12-24',
    2028: '12-12',
    2029: '12-01',
    2030: '12-20',
    2031: '12-09',
    2032: '11-27',
    2033: '12-16',
    2034: '12-06',
    2035: '12-25',
    2036: '12-13',
    2037: '12-03',
    2038: '12-22',
    2039: '12-12',
    2040: '11-30'
  };

  const date = knownDates[year];
  return date ? dayjs(`${year}-${date}`) : null;
}

export { getEasterDate, getHanukkahDate };
